import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Conversation is now rendered inline inside SmsInboxPage (split-panel layout).
// Redirect anyone who lands on the old URL back to the inbox.
const SmsConversationPage: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/sms/inbox', { replace: true });
  }, [navigate]);
  return null;
};

export default SmsConversationPage;
